// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-fix-tab":"FixTab_load-shedding-fix-tab___V8KG"};